import React, {useEffect, useRef, useState} from "react";
import styles from "./UserDropdown.module.css";

type Props = {
    email: string | undefined;
    onLogout: () => void;
    onChangePassword: () => void;
    onChangeEmail: () => void;
};

const UserDropdown: React.FC<Props> = ({email, onLogout, onChangePassword, onChangeEmail}) => {
    const [open, setOpen] = useState(false);
    const dropdownRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
                setOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    return (
        <div className={styles.userDropdown} ref={dropdownRef}>
            <button
                className={styles.userToggle}
                title={email ?? "User"}
                onClick={() => setOpen(!open)}
            >
                {email ?? "User"} ▼
            </button>
            {open && (
                <div className={styles.userMenu}>
                    <ul>
                        <li>
                            <button onClick={onChangePassword}>Change Password</button>
                        </li>
                        <li>
                            <button onClick={onChangeEmail}>Change Email</button>
                        </li>
                        <li>
                            <button onClick={onLogout}>Logout</button>
                        </li>
                    </ul>
                </div>
            )}
        </div>
    );
};

export default UserDropdown;